export class AnalyticsService {
    constructor() {
    }

    static consentModeTypes = [
        'functionality_storage',
        'security_storage',
        'ad_storage',
        'ad_user_data',
        'analytics_storage',
        'personalization_storage',
        'ad_personalization'
    ];

    static sendEvent(event, data = {}) {
        const lmsUserData = costorage.get('h_lmsUser');
        let parsedLmsUserData;

        if (lmsUserData) {
            parsedLmsUserData = JSON.parse(lmsUserData);
        }

        if (parsedLmsUserData && parsedLmsUserData['_id']) {
            Object.assign(data, { lms_id: parsedLmsUserData['_id'] });
        }

        dataLayer.push({
            event: event,
            ...data
        });
    }

    static setConsent(consent) {
        const consentMode = {
            'functionality_storage': consent.necessary ? 'granted' : 'denied',
            'security_storage': consent.necessary ? 'granted' : 'denied',
            'ad_storage': consent.marketing ? 'granted' : 'denied',
            'ad_user_data': consent.marketing ? 'granted' : 'denied',
            'analytics_storage': consent.analytics ? 'granted' : 'denied',
            'personalization_storage': consent.preferences ? 'granted' : 'denied',
            'ad_personalization': consent.preferences ? 'granted' : 'denied',
        };
        gtag('consent', 'update', consentMode);
        costorage.set('h_consentMode', JSON.stringify(consentMode), { expires: 365 * 24 * 60 * 60, path: '/', domain: `.${location.hostname.split('.').reverse()[1]}.${location.hostname.split('.').reverse()[0]}` });
    }
}